import '@pharmsnap/pharmsnap-web/assets/icon-svg/check.svg'
import { defineComponent, onBeforeUnmount, watch } from '@vue/composition-api'
import { GDialog, GIcon } from 'pharmsnapMF_shared/components'
import cn from './locales/cn.json'
import en from './locales/en.json'
import jp from './locales/jp.json'

export default defineComponent({
  name: 'FeedbackSuccessDialog',
  i18n: {
    messages: {
      cn,
      en,
      jp,
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    let timer: ReturnType<typeof setTimeout> | null = null

    // 监听 visible 变化，当弹窗显示时启动 3 秒倒计时
    watch(
      () => props.visible,
      (newVal) => {
        // 清除之前的定时器
        if (timer) {
          clearTimeout(timer)
          timer = null
        }

        // 如果弹窗显示，3 秒后自动关闭
        if (newVal) {
          timer = setTimeout(() => {
            ctx.emit('close')
            timer = null
          }, 3000)
        }
      },
      { immediate: true }
    )

    // 组件卸载前清除定时器
    onBeforeUnmount(() => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    })

    return {}
  },
  render() {
    return (
      <GDialog
        append-to-body={true}
        showFooter={false}
        onClose={() => this.$emit('close')}
        destroy-on-close={true}
        close-on-click-modal={false}
        visible={this.visible}
        width="500px"
        title=" "
      >
        <div class="flex mb-8 justify-center">
          <GIcon svgName="Check" size={60} class="flex-shrink-0"></GIcon>
        </div>
        <div class="text-center text-text-t1 text-tiny">{this.$t('submitSuccess')}</div>
      </GDialog>
    )
  },
})
